
// Platforms
export function isIOS(){
   return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
export function isAndroid(){
   return /android/.test(navigator.userAgent);
}

// Browsers
export function isChrome(){
   return /Chrome/.test(navigator.userAgent);
}
export function isFirefox(){
   return /Firefox/.test(navigator.userAgent);
}
export function isEdge(){
   return /Edg/.test(navigator.userAgent);
}
export function isSafari(){
   return /Safari/.test(navigator.userAgent) && !isChrome() && !isEdge();
}
export function isOpera(){
   return /Opera/.test(navigator.userAgent);
}
export function isInternetExplorer(){
   return /MSIE/.test(navigator.userAgent);
}

export const platform = {
   desktop: 'platform-desktop',
   android: 'platform-android',
   ios: 'platform-ios'
};

export const browser = {
   chrome: 'browser-chrome',
   safari: 'browser-safari',
   firefox: 'browser-firefox',
   edge: 'browser-edge',
   opera: 'browser-opera',
   internetExplorer: 'browser-ie',
};

export default function(){
   // Set the platform
   if(isIOS())document.body.classList.add(platform.ios);
   else if(isAndroid()) document.body.classList.add(platform.android);
   else document.body.classList.add(platform.desktop);
   
   // Set the browser
   if(isChrome()) document.body.classList.add(browser.chrome);
   if(isFirefox()) document.body.classList.add(browser.firefox);
   if(isEdge()) document.body.classList.add(browser.edge);
   if(isSafari()) document.body.classList.add(browser.safari);
   if(isOpera()) document.body.classList.add(browser.opera);
   if(isInternetExplorer()) document.body.classList.add(browser.internetExplorer);
}